<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="row">
					<div class="col-sm-6 col-lg-6">
						<form class="form-horizontal">
							<div class="form-group">
								<label class="col-sm-4 control-label">School</label>
								<div class="col-sm-8 col-md-6 col-lg-5">
									<select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="notification.SchoolID">
										<option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">
											{{ o.SchoolName }}
										</option>
									</select>
								</div>
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label">Notification type</label>
								<div class="col-sm-8 col-md-6 col-lg-5">
									<select
										class="form-control"
										name="NotificationTypeID"
										(ngModelChange)="onChangeNotificationType($event)"
										[(ngModel)]="notification.NotificationTypeID"
									>
										<option value="" style="display: none"></option>
										<option *ngFor="let o of notificationTypeList" [ngValue]="o.NotificationTypeID">
											{{ o.NotificationTypeDesc }}
										</option>
									</select>
								</div>
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label">Active</label>
								<div class="col-sm-8 col-md-6 col-lg-8">
									<input type="checkbox" name="Active" class="custom" [(checked)]="notification.Active" />
								</div>
								<div class="form-group"></div>
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label">Include First Name</label>
								<div class="col-sm-8 col-md-6 col-lg-8">
									<input
										type="checkbox"
										name="IncludeFirstName"
										class="custom"
										(change)="onFirstNameChange($event.target.checked)"
										[(checked)]="notification.IncludeFirstName"
									/>
								</div>
								<div class="form-group"></div>
							</div>

							<div class="form-group" *ngIf="enable_IncludeEntryDate">
								<label class="col-sm-4 control-label">{{ IncludeEntryDate_label }}</label>

								<div class="col-sm-8 col-md-6 col-lg-8">
									<input
										type="checkbox"
										name="IncludeEntryDate"
										class="custom"
										(change)="onEntryDateChange($event.target.checked)"
										[(checked)]="notification.IncludeEntryDate"
									/>
								</div>
								<div class="form-group"></div>
							</div>

							<div class="form-group" *ngIf="enable_IncludeEntryTime">
								<label class="col-sm-4 control-label">{{ IncludeEntryTime_label }}</label>
								<div class="col-sm-8 col-md-6 col-lg-8">
									<input
										type="checkbox"
										name="IncludeEntryTime"
										class="custom"
										(change)="onEntryTimeChange($event.target.checked)"
										[(checked)]="notification.IncludeEntryTime"
									/>
								</div>
								<div class="form-group"></div>
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label">Language</label>
								<div class="col-sm-8 col-md-6 col-lg-5">
									<select class="form-control" name="LanguageID" [(ngModel)]="notification.LanguageID">
										<option *ngFor="let o of languageList" [ngValue]="o.LanguageID">
											{{ o.LanguageDesc }}
										</option>
									</select>
								</div>
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label">AdmitTime</label>

								<div class="col-sm-8 col-md-6 col-lg-5">
									<p-calendar
										[timeOnly]="true"
										name="AdmitTime"
										[(ngModel)]="notification.AdmitTime"
										hourFormat="12"
										name="txtAdmitTime"
									></p-calendar>
								</div>
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label">Message</label>
								<div class="col-sm-8 col-md-6 col-lg-5">
									<textarea row="4" class="form-control" name="Message" [(ngModel)]="notification.Message"></textarea>
								</div>
							</div>

							<div id="SaveErrorMessage" *ngIf="SaveErrorMessage" class="alert alert-danger">
								{{ SaveErrorMessage }}
							</div>

							<div class="form-group">
								<label class="col-sm-4 control-label"></label>
								<div class="col-sm-8 col-md-6 col-lg-8">
									<div name="Saveing" style="display: none" class="alert alert-info">Saving.Please wait...</div>
									<button name="btnSaving" class="btn btn-primary" type="button" (click)="SaveNotification()">Save Notification</button>
									&nbsp;
									<button class="btn btn-default" type="button" (click)="Cancel()">Cancel</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
